module.exports = __webpack_public_path__ + "img/myanmar.f30e355c.svg";